import { $Handrail } from '../__generated/enhanced-model.js';
import { HandrailType, PositionType, PostStainlessFinishType, PostType } from '../__generated/model/index.js';
import { DataBindingBuilder } from '../sdk/data-binding.js';
import { Materials } from './materials.js';
import { ObjectNames } from './objects.js';
const handrailPartData = DataBindingBuilder.from('handrailPartData', $Handrail, [
    '$postType',
    '$handrailType',
    '$postFinish',
    'leftPositionType',
    'rightPositionType'
], [
    // #regionTimber posts
    {
        keys: {
            $postType: PostType.Timber,
            $handrailType: HandrailType.values(),
            $postFinish: PostStainlessFinishType.values(),
            leftPositionType: PositionType.values(),
            rightPositionType: PositionType.values()
        },
        values: {
            handrailSku: null,
            handrailObjectName: ObjectNames.handrailWooden,
            joinerSku: null,
            joinerObjectName: null,
            material: Materials.Wood,
            scaleWood: true,
            angled: true
        }
    },
    // #endregion
    // #region Metal posts - Timber
    {
        keys: {
            $postType: PostType.Metal,
            $handrailType: HandrailType.FlatTimber,
            $postFinish: PostStainlessFinishType.values(),
            leftPositionType: PositionType.values(),
            rightPositionType: PositionType.values()
        },
        values: {
            handrailSku: null,
            handrailObjectName: ObjectNames.handrailWooden,
            joinerSku: null,
            joinerObjectName: null,
            material: Materials.Wood,
            scaleWood: true,
            angled: true
        }
    },
    // #endregion
    // #region Metal posts - Square Stainless
    {
        keys: {
            $postType: PostType.Metal,
            $handrailType: HandrailType.SquareStainless,
            $postFinish: PostStainlessFinishType.Satin,
            leftPositionType: PositionType.values(),
            rightPositionType: PositionType.values()
        },
        values: {
            handrailSku: 'ST-S-316-2-MTR',
            joinerSku: 'HR-SS-2004',
            handrailObjectName: ObjectNames.handrailSquareTube,
            joinerObjectName: ObjectNames.joinerSquareSatin,
            material: Materials.MetalSatin
        }
    },
    {
        keys: {
            $postType: PostType.Metal,
            $handrailType: HandrailType.SquareStainless,
            $postFinish: PostStainlessFinishType.Mirror,
            leftPositionType: PositionType.values(),
            rightPositionType: PositionType.values()
        },
        values: {
            handrailSku: 'ST-P-316-2-MTR',
            joinerSku: 'HR-2004',
            joinerObjectName: ObjectNames.joinerSquareMirror,
            handrailObjectName: ObjectNames.handrailSquareTube,
            material: Materials.MetalMirrorPolish
        }
    },
    // #endregion
    // #region Metal posts - Round Stainless
    {
        keys: {
            $postType: PostType.Metal,
            $handrailType: HandrailType.RoundStainless,
            $postFinish: PostStainlessFinishType.Satin,
            leftPositionType: PositionType.values(),
            rightPositionType: PositionType.values()
        },
        values: {
            handrailSku: 'RT-S-316-2-MTR',
            joinerSku: 'HR-S-2004E',
            handrailObjectName: ObjectNames.handrailRoundTube,
            joinerObjectName: ObjectNames.joinerRound,
            material: Materials.MetalSatin
        }
    },
    {
        keys: {
            $postType: PostType.Metal,
            $handrailType: HandrailType.RoundStainless,
            $postFinish: PostStainlessFinishType.Mirror,
            leftPositionType: PositionType.values(),
            rightPositionType: PositionType.values()
        },
        values: {
            handrailSku: 'RT-P-316-2-MTR',
            joinerSku: 'HR-2004E',
            handrailObjectName: ObjectNames.handrailRoundTube,
            joinerObjectName: ObjectNames.joinerRound,
            material: Materials.MetalMirrorPolish
        }
    }
]);
export const HandrailBindings = {
    handrailPartData
};

//# sourceMappingURL=handrail.js.map